import { faCreditCard, faDollar, faList, faListCheck, faUsers, faPeopleGroup, faHome, faCalendarAlt, faDesktop } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


export var MENUITEMS = [
    {
        menutitle: 'Folio',
        Items: [
            {
                title: 'Folio', faicon: faHome, type: 'link', active: false, path: '/folio'
            },
        ]
    },
    {
        menutitle: 'Services',
        Items: [
            {
                title: 'Services', faicon: faListCheck, type: 'link', active: false, path: '/services'
            },
        ]
    },
    {
        menutitle: 'Hardware Dashboard',
        Items: [
            {
                title: 'Hardware Dashboard', faicon: faDesktop, type: 'link', active: false, path: '/hardware-dashboard'
            },
        ]
    },
    {
        menutitle: 'Reservations',
        Items: [
            {
                title: 'Reservations', faicon: faList, type: 'link', active: false, path: '/mobile-app-reservations'
            },
        ]
    },
    {
        menutitle: 'Meetings',
        Items: [
            {
                title: 'Meetings', faicon: faCalendarAlt, type: 'link', active: false, path: '/meetings'
            },
        ]
    },
    {
        menutitle: 'Mobile Users',
        Items: [
            {
                title: 'Mobile Users', faicon: faUsers, type: 'link', active: false, path: '/mobile-users'
            },
        ]
    },
    {
        menutitle: 'Payment Transaction',
        Items: [
            {
                title: 'Payment Transaction', faicon: faCreditCard, type: 'link', active: false, path: '/payment-transaction'
            },
        ]
    },
    {
        menutitle: 'Inventory Management',
        Items: [
            {
                title: 'Inventory Management', faicon: faPeopleGroup, type: 'link', active: false, path: '/inventory-management'
            },
        ]
    },
    {
        menutitle: 'IoT Dashboard',
        Items: [
            {
                title: 'IoT Dashboard', faicon: faList, type: 'link', active: false, path: '/iot-dashboard'
            },
        ]
    },
    {
        menutitle: '360 Customer Profile',
        Items: [
            {
                title: '360 Customer Profile', faicon: faPeopleGroup, type: 'link', active: false, path: '/profile-360'
            },
        ]
    },
];
